<template>
  <v-container>
    <v-card>
      <v-card-title class="accent text-h5 font-weight-bold pa-3">
        <v-icon color="primary" left>mdi-account-group</v-icon>
        Clientes
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <ListaClientes />
      </v-card-text>
    </v-card>

    <!-- <h3 class="text-h4 mb-4 blue-grey--text text--darken-2">
      <v-icon color="primary" x-large left>mdi-account-group</v-icon>
      Clientes
    </h3> -->
  </v-container>
</template>

<script>
export default {
  name: "Clientes",

  components: {
    ListaClientes: () => import("./components/ListaClientes"),
  },
};
</script>

<style lang="scss"></style>
